import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./components/Home/Home";
import NotFound from "./components/NotFound/NotFound";
import Login from "./components/Login/Login";
import Summary from "./components/Summary/Summary";
import "./styles/fonts.scss"

const App = () => {
  return (
    <div>
      <Router>
        <Switch>
          <Route
            path="/summary/:host/:id"
            component={(props) => <Summary {...props} />}
          />
          <Route
            path="/not-found/:host"
            render={(props) => <NotFound {...props} />}
          />
          <Route
            path="/login/:host/:id"
            render={(props) => <Login {...props} />}
          />
          <Route exact path="/" render={(props) => <Home {...props} />} />
        </Switch>
      </Router>
    </div>
  );
};

export default App;
